import axios from "axios";

const api = axios.create({
  baseURL: "/api",
  headers: { "Content-Type": "application/json" },
});

// Restore token after WebView reload (e.g. returning from Tonkeeper)
const saved = sessionStorage.getItem("sb_token");
if (saved) {
  api.defaults.headers.common["Authorization"] = `Bearer ${saved}`;
}

export const setToken = (token: string) => {
  api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  sessionStorage.setItem("sb_token", token);
};

export default api;
